import { type ReactNode } from 'react'
import { usePortalTheme } from '@/hooks/usePortalTheme'

/* ==========================================================================
   Theme Provider Component
   Task F30: White-Label Theme System

   Wrapper component that applies pharmacy-specific theme colors.
   Must be used within a PortalProvider.
   ========================================================================== */

interface ThemeProviderProps {
  children: ReactNode
}

/**
 * Applies pharmacy-specific CSS custom properties for white-labeling.
 * Should wrap portal content that needs themed styling.
 *
 * @example
 * ```tsx
 * <PortalProvider>
 *   <ThemeProvider>
 *     <PortalLayout />
 *   </ThemeProvider>
 * </PortalProvider>
 * ```
 */
export function ThemeProvider({ children }: ThemeProviderProps) {
  // Apply theme CSS variables from portal config
  usePortalTheme()

  return <>{children}</>
}

export default ThemeProvider
